import React from 'react';
import {
  Table,
  TableCell,
  TableBody,
  TableRow,
  TableHead,
  Box,
  Grid,
  styled,
} from '@mui/material';
import { Api } from 'further-types/allocations';

const StyledNote = styled(Box)(({ theme }) => ({
  fontSize: theme.fontSizes?.regular,
  color: theme.palette.text.darkBodyText,
  marginBottom: theme.spacing(6),
}));

const StyledTableHead = styled(TableHead)(() => ({
  backgroundColor: 'rgba(234, 233, 232, .2)',
}));

const StyledTableHeadCell = styled(TableCell)(({ theme }) => ({
  minWidth: 120,
  borderBottomColor: theme.palette?.borderColor?.lightGrey,
  lineHeight: '22px',
  fontSize: theme.fontSizes?.sm,
  fontWeight: 700,
  fontStyle: 'normal',
}));

const StyledTableBodyCell = styled(TableCell)(({ theme }) => ({
  borderBottomColor: theme.palette?.borderColor?.lightGrey,
  color: theme.palette.text.darkBodyText,
  fontSize: theme.fontSizes?.regular,
}));

const ErrorTable: React.FC<{ errors: Array<Api.RowError> }> = ({ errors }) => {
  return (
    <Grid size={{ md: 12 }}>
      <StyledNote>
        The following allocation data cannot be processed as the data provided
        is either incomplete or incorrect. Please review the below errors,
        correct your spreadsheet and process your upload again.
      </StyledNote>
      <Table>
        <StyledTableHead>
          <TableRow>
            <StyledTableHeadCell>Name</StyledTableHeadCell>
            <StyledTableHeadCell>Spreadsheet errors</StyledTableHeadCell>
            <StyledTableHeadCell>Allocation errors</StyledTableHeadCell>
          </TableRow>
        </StyledTableHead>
        <TableBody>
          {errors.map((row) => {
            return (
              <TableRow key={row.lineNo}>
                <StyledTableBodyCell>{row.name}</StyledTableBodyCell>
                <StyledTableBodyCell>
                  {row.spreadsheetErrors.join(', ')}
                </StyledTableBodyCell>
                <StyledTableBodyCell>
                  {row.allocationErrors.join(', ')}
                </StyledTableBodyCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </Grid>
  );
};

export default ErrorTable;
